import React from "react";
import {
  createStyles,
  Table,
  TableContainer,
  withStyles,
} from "@material-ui/core";
import tableProps from "./types";

const StyledTableContainer = withStyles(() =>
  createStyles({
    root: {
      backgroundColor: `#fff`,
      borderRadius: `4px`,
    },
  })
)(TableContainer);

export function TableMobile(props: tableProps) {
  return (
    <StyledTableContainer>
      <Table aria-label="customized table">{props.Rows(props.data)}</Table>
    </StyledTableContainer>
  );
}
